<template>
  <div class="modal fade" id="descriptionModal" tabindex="-1" role="dialog" aria-labelledby="descriptionModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="descriptionModalLabel">Description</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="custom-label">Description</label>
            <br>
            <textarea class="form-control" rows="5" v-model="description"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary" @click="$emit('saveDescription', description)">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['promo'],
    data() {
      return {
        description: this.promo.pivot.description,
      }
    },
    watch: {
      promo(newP, oldP) {
        this.description = newP.pivot.description
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/DescriptionModal.vue